import React, { useEffect, useMemo, useRef, useState } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

import Typography from "../Typography/Typography";
import ButtonMore from "../Button/ButtonMore/ButtonMore";

import styles from "./FeaturedSectionContent.module.scss";

const getFullWidth = (element) => {
  const style = element.currentStyle || window.getComputedStyle(element),
    width = element.offsetWidth, // or use style.width
    margin = parseFloat(style.marginLeft) + parseFloat(style.marginRight),
    padding = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight),
    border = parseFloat(style.borderLeftWidth) + parseFloat(style.borderRightWidth);

  return parseInt(width + margin + padding + border, 10);
};

const MIN_SHOW_COUNT = 2;
const MAX_SHOW_COUNT = 5;

const FeaturedSectionContent = ({
  book,
  onItemClick,
  onContextMenu,
  BookCoverView,
  Badge,
  withoutMore,
}) => {
  const contentRef = useRef();
  const hiddenContentRef = useRef();
  const [elementCount, setElementCount] = useState(0);
  const [isShowMore, setElementWidth] = useState(false);
  const [isMore, setIsMore] = useState(MIN_SHOW_COUNT);

  useEffect(() => {
    if (contentRef.current && hiddenContentRef.current) {
      const containerWidth = contentRef.current.offsetWidth;
      const items = hiddenContentRef.current.querySelectorAll(".featured-section__link");
      const threeLinesWidth = containerWidth * isMore + containerWidth / 2;

      let elementsWidth = 0;
      let elementsCount = 0;
      let isShowMore = false;

      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        const width = getFullWidth(item);

        if (elementsWidth < threeLinesWidth) {
          elementsWidth += width;
          elementsCount += 1;
        } else {
          isShowMore = true;
        }
      }
      setElementWidth(isShowMore);
      setElementCount(elementsCount);
    }
  }, [book.links, isMore]);

  const links = useMemo(() => {
    if (elementCount === 0) {
      return book.links;
    }
    return book.links.slice(0, elementCount);
  }, [book.links, elementCount]);

  const toggleShow = () => {
    if (isMore === MIN_SHOW_COUNT) {
      setIsMore(MAX_SHOW_COUNT);
    } else {
      setIsMore(MIN_SHOW_COUNT);
    }
  };


  return (
    <div
      key={book.book_id}
      className={classNames(styles["featured-section__item"], "featured-section__item")}
    >
      <div className={styles["featured-section__image"]}>
        <BookCoverView book={book} />
      </div>
      <div>
        <div className={classNames(styles["featured-section__title"], "featured-section__title")}>
          <Typography
            threeDots
            color="default"
            variant="body2"
            className={classNames(styles["featured-section__title-text"])}
          >{book.title}</Typography>
          <Badge number={book.links.length} />
        </div>
        <ul
          ref={hiddenContentRef}
          className={classNames(styles["featured-section__links"], styles["hidden"], "hidden")}
        >
          {book.links.map((link) => (
            <li
              key={link.para_id}
              className={classNames(styles["featured-section__link"], "featured-section__link")}
            >
              <span
                className={classNames(
                  styles["featured-section__link-text"],
                  "featured-section__link-text"
                )}
              >{link.ref}</span>
            </li>
          ))}
        </ul>
        <ul
          ref={contentRef}
          className={classNames(styles["featured-section__links"], "featured-section__links")}
        >
          {links.map((link) => {
            return (
              <li
                key={link.para_id}
                className={classNames(styles["featured-section__link"], "featured-section__link")}
                tabIndex={-1}
                onContextMenu={onContextMenu ? (e) => onContextMenu(e, link) : null}
              >
                <span
                  className={classNames(
                    styles["featured-section__link-text"],
                    "featured-section__link-text"
                  )}
                  onClick={() => onItemClick(link.para_id)}
                  dangerouslySetInnerHTML={{ __html: link.ref }}
                />
              </li>
            );
          })}
          {isShowMore && !withoutMore && (
            <ButtonMore
              key='btn-more'
              className={styles["btn-more"]}
              paddingLess
              isMoreActive={isMore === MAX_SHOW_COUNT}
              onClick={toggleShow}
            />
          )}
        </ul>
      </div>
    </div>
  );
};

FeaturedSectionContent.propTypes = {
  book: PropTypes.object,
  onItemClick: PropTypes.func,
  onContextMenu: PropTypes.func,
  BookCoverView: PropTypes.func,
  Badge: PropTypes.func,
  withoutMore: PropTypes.bool,
  i18nTranslate: PropTypes.func,
};

export default FeaturedSectionContent;
